<template>
    <div>
        <div class="w-full text-center">
            <button type="submit" class="border-0 rounded-lg w-full text-white font-bold h-16 text-xl duration-300 transition-colors outline-none focus:outline-none" 
            :class="[ bgClass, this.$attrs['class']]">
                <slot></slot>
            </button>
        </div>
    </div>
</template>

<script>
import { isString } from "underscore";
export default {
    props: {
        'form': {},
        'backgroundClass': {
            type: String,
            default: 'bg-red'
        }
    },
    computed: {
        bgClass() {
            return this.form.submitting ? 'bg-gray-800' : this.backgroundClass;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>